/* eslint-disable max-len */
//TODO:  Refactor so that we can synchronously check rights.    This implementation requires that rights be retrieved using loadPermissions before using objectHasPermission
//TODO:  Refactor so that permissions are stored in a keyed json object.   Translate from permissioncollection array.    This is for better performance!!!
//TODO: Make object and right comparisons case insensitive
import { Injectable } from '@angular/core';
import { DataService } from '@Core/services/proprietary/data.service';
import { Datasource } from '@Core/services/proprietary/datasource';

@Injectable()
export class PermissionService {
    private dsPermission: Datasource;

    constructor(private ds: DataService) {
        this.dsPermission = ds.addNewDatasource('Permission', 'NO-CACHE');
        this.dsPermission.getCollection({ View: 'Full' }, false);
    }

    objectHasPermission(object: string, right: string = 'View_Object_Ind') {
        //console.log("checking permission for " + object + "...");
        let permCount = this.dsPermission.objectNodes.length;

        for (var i = 0; i < permCount; i++) {
            //console.log("test " + i);
            //console.log("test=" + this.dsPermission.objectNodes[i].Object_Code + " " + this.dsPermission.objectNodes[i].Permission_Type );
            if (
                this.dsPermission.objectNodes[i].Object_Code == object &&
                this.dsPermission.objectNodes[i].Permission_Type == 'OBJECT'
            ) {
                return this.dsPermission.objectNodes[i][right] == 'Y' || false; //uppercase is temporary to get around defect in PermissionCollection where all elements names are uppercased
            }
        }

        //overide for development testing before C1 object is created as security is added
        //if (object == 'BookStats') return true;

        return false;
    }

    loadPermissions(object: string = '', right: string = 'View_Object_Ind', permissionType: string = 'OBJECT') {
        //console.log('loading permissions for ' + object);
        this.dsPermission.getCollection({
            View: 'Full',
            Object: object,
            Right: right,
            Permission_Type: permissionType
        });
    }

    refresh() {
        // re-retrieve permissions -- currently used when changing books
        this.dsPermission.refresh();
    }
}
